import BaseBlock from "@/ts/base/Components/Blocks/BaseBlock";

class WpImage extends BaseBlock {

	protected img!: HTMLImageElement|null;

	init() {
		this.img = this.block.querySelector("img");
		if (this.img) {
			this.addDimensions();
		}
	}

	addDimensions(): void {
		if (!this.img) {
			return;
		}

		this.img.style.width = this.img.getAttribute("width") + "px";
	}
}

export default WpImage;
